import { render, staticRenderFns } from "./SelectServe.vue?vue&type=template&id=8bf477f6&"
import script from "./SelectServe.vue?vue&type=script&lang=js&"
export * from "./SelectServe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports